'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (keywords, sortmode) {
  return keywords && sortmode !== 'ListedDate' ? 'KeywordRelevance' : 'ListedDate';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/evaluateSortMode.js
 ** module id = 434
 ** module chunks = 0
 **/